import { render, staticRenderFns } from "./OptimizationHint.vue?vue&type=template&id=514f3f35&scoped=true&"
import script from "./OptimizationHint.vue?vue&type=script&lang=ts&"
export * from "./OptimizationHint.vue?vue&type=script&lang=ts&"
import style0 from "./OptimizationHint.vue?vue&type=style&index=0&id=514f3f35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514f3f35",
  null
  
)

export default component.exports